import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import TriviaTrackContainer from "./TriviaTrackContainer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectEventsData, setEventData } from "../../../store/events";
import { EVENTS } from "../../../analytics/events";
import { sendAnalyticsEvents } from "../../../analytics/common";

const Q1 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventsData = useSelector(selectEventsData);
  const Q1Options = useMemo(() => {
        return [
          {
            id: 0,
            name: t("no"),
            value: 'No',
            score: 9
          },
          {
            id: 1,
            name: t("yes"),
            value: 'Yes',
            score: 1
          },
          {
            id: 2,
            name: t("not_sure"),
            value: 'NotSure',
            score: 5
          },
        ];
    }, [t]);

    const onSingleClick = (q1) => {
      dispatch(setEventData({ id: 'Q1', data: q1 }))
      sendAnalyticsEvents(EVENTS.onboardingQ1Submitted, {
        ...eventsData,
        Q1: q1,
      })
      navigate('/trivia-press');
    }

    return (
      <TriviaTrackContainer
        withImg
        pageEvent={"onboardingQ1Shown"}
        title={t("trivia_question_1")}
        options={Q1Options}
        onSingleClick={onSingleClick}
        questionIndex={0}
      />
    );
}

export default Q1;